module.exports = __webpack_public_path__ + "static/media/ssl-animacao.50bba5bf.webm";